import { __assign, __rest } from "tslib";
import cx from 'classnames';
import { mapValues, noop } from 'lodash-es';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Guide from '../../containers/handoff/Guide';
import { getPercentageValue } from '../../utils/handoff/guide';
import styles from './Element.module.css';
export default function Element(_a) {
    var _b;
    var showGuides = _a.showGuides, isSelected = _a.isSelected, isHovered = _a.isHovered, left = _a.left, top = _a.top, width = _a.width, height = _a.height, artboardWidth = _a.artboardWidth, artboardHeight = _a.artboardHeight, zoomScale = _a.zoomScale, pixelRatio = _a.pixelRatio, onClick = _a.onClick, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut;
    var style = mapValues({ left: left, top: top, width: width, height: height }, function (v) { return v * zoomScale * pixelRatio; });
    var className = cx(styles.element, (_b = {},
        _b[styles.selected] = isSelected,
        _b[styles.hovered] = isHovered,
        _b));
    return (React.createElement("div", null,
        showGuides &&
            renderGuides({
                left: left,
                top: top,
                width: width,
                height: height,
                artboardWidth: artboardWidth,
                artboardHeight: artboardHeight,
                pixelRatio: pixelRatio,
            }),
        React.createElement("div", { className: className, onClick: onClick, onMouseOut: onMouseOut, onMouseOver: onMouseOver, style: style }, isSelected && (React.createElement("div", null,
            React.createElement("div", { className: styles.handle, style: { top: -2, left: -2 } }),
            React.createElement("div", { className: styles.handle, style: { bottom: -2, left: -2 } }),
            React.createElement("div", { className: styles.handle, style: { top: -2, right: -2 } }),
            React.createElement("div", { className: styles.handle, style: { bottom: -2, right: -2 } }))))));
}
Element.propTypes = {
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    artboardWidth: PropTypes.number.isRequired,
    artboardHeight: PropTypes.number.isRequired,
    showGuides: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isHovered: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    zoomScale: PropTypes.number.isRequired,
    pixelRatio: PropTypes.number.isRequired,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
};
Element.defaultProps = {
    onClick: noop,
    onMouseOver: noop,
    onMouseOut: noop,
};
// eslint-disable-next-line react/prop-types
function renderGuides(_a) {
    var pixelRatio = _a.pixelRatio, elementPositionAndSize = __rest(_a, ["pixelRatio"]);
    return (React.createElement(Fragment, null,
        React.createElement(Guide, __assign({ key: "north" }, northGuide(elementPositionAndSize, pixelRatio), { isVertical: true })),
        React.createElement(Guide, __assign({ key: "south" }, southGuide(elementPositionAndSize, pixelRatio), { isVertical: true })),
        React.createElement(Guide, __assign({ key: "west" }, westGuide(elementPositionAndSize, pixelRatio))),
        React.createElement(Guide, __assign({ key: "east" }, eastGuide(elementPositionAndSize, pixelRatio)))));
}
function northGuide(_a, pixelRatio) {
    var left = _a.left, width = _a.width, top = _a.top, artboardHeight = _a.artboardHeight;
    var ruleLeft = left + width / 2;
    var ruleHeight = top;
    var value = ruleHeight;
    return {
        left: ruleLeft * pixelRatio,
        top: 0,
        height: ruleHeight * pixelRatio,
        value: value,
        pctValue: getPercentageValue(value, artboardHeight),
    };
}
function southGuide(_a, pixelRatio) {
    var left = _a.left, width = _a.width, top = _a.top, height = _a.height, artboardHeight = _a.artboardHeight;
    var ruleLeft = left + width / 2;
    var ruleTop = top + height;
    var ruleHeight = artboardHeight - ruleTop;
    var value = artboardHeight - ruleTop;
    return {
        left: ruleLeft * pixelRatio,
        top: ruleTop * pixelRatio,
        height: ruleHeight * pixelRatio,
        value: value,
        pctValue: getPercentageValue(value, artboardHeight),
    };
}
function westGuide(_a, pixelRatio) {
    var top = _a.top, height = _a.height, left = _a.left, artboardWidth = _a.artboardWidth;
    var ruleTop = top + height / 2;
    var ruleWidth = left;
    var value = ruleWidth;
    return {
        left: 0,
        top: ruleTop * pixelRatio,
        width: ruleWidth * pixelRatio,
        value: value,
        pctValue: getPercentageValue(value, artboardWidth),
    };
}
function eastGuide(_a, pixelRatio) {
    var top = _a.top, height = _a.height, left = _a.left, width = _a.width, artboardWidth = _a.artboardWidth;
    var ruleTop = top + height / 2;
    var ruleLeft = left + width;
    var ruleWidth = artboardWidth - ruleLeft;
    var value = artboardWidth - ruleLeft;
    return {
        left: ruleLeft * pixelRatio,
        top: ruleTop * pixelRatio,
        width: ruleWidth * pixelRatio,
        value: artboardWidth - ruleLeft,
        pctValue: getPercentageValue(value, artboardWidth),
    };
}
